
import { defineComponent, ref, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { Toast } from 'vant'
import { Device } from '@loca/mfe-vue3'
import { t } from '@/i18n'
import { MenuItem } from '@/models/Menu.model'
import { getMenuList } from '@/utils/menuList'

export default defineComponent({
  name: 'IndexPage',

  setup() {
    const router = useRouter()
    const isMobile = Device.isMobile()
    const menuList = ref<MenuItem[]>([])

    // 获取有权限的菜单
    async function updateMenuList() {
      menuList.value = await getMenuList()
    }

    // pc端 - 自动跳转至有权限的第一个页面
    function autoJumpToFirstMenuPage(list: MenuItem[]): boolean {
      let res = false

      if (list && list.length) {
        let targetLink = ''
        for (let i = 0; i < list.length; i++) {
          const children = list[i].children || []
          if (children.length) {
            res = autoJumpToFirstMenuPage(children)
            if (res) break
          } else if (list[i].link) {
            targetLink = list[i].link as string
            res = true
            break
          }
        }
        if (targetLink) {
          setTimeout(() => router.replace(targetLink))
        }
      }

      return res
    }

    async function _redirect() {
      if (isMobile) {
        // 由于首页性能原因，移动端默认进入“工作台”
        setTimeout(() => router.replace('/house/discoverMp'))
      } else {
        router.replace('/house')

        // Toast.loading({
        //   message: t('loading') as string,
        //   forbidClick: true,
        //   duration: 30000
        // })

        // // 获取菜单列表
        // await updateMenuList()
        //
        // // 尝试自动跳转第一个有权限的菜单页面
        // const res = autoJumpToFirstMenuPage(menuList.value)
        // // 若无法自动进入任何一个菜单页面，则进入无权限页
        // if (!res) setTimeout(() => router.push('/error'))

        // Toast.clear()
      }
    }

    onActivated(() => {
      _redirect()
    })
  }
})
